export const environment = {
  production: true,
  productName: 'File360',
  productVersion: '9.0.0202.2261',
  productMajorMinor: '9.0',
  year: '2021',
};







